import { RootState } from "../../../../store/types";
import { connect } from "react-redux";
import PlanSummary from "./index";

interface OwnProps {
    buttonLabel: string;
    onButtonClick: () => void;
    disableButton: boolean;
}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => ({
    planId: state.reviewAndPublish.shiftPlanOutput?.planId,
    totalOverrides: state.reviewAndPublish.shiftPlanOutput?.overrides?.total,
    onButtonClick: ownProps.onButtonClick,
    buttonLabel: ownProps.buttonLabel,
    disableButton: ownProps.disableButton
});

export default connect(mapStateToProps)(PlanSummary);